module.exports = __webpack_public_path__ + "media/qualitySchBg.cc71fe47.mp4";